module.exports = __webpack_public_path__ + "static/img/telefon.7f6d4e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/telefon.jpg
// module id = Gl3a
// module chunks = 1